import "./home-landing-booking-steps.component.scss";

export default {
  template: require('./home-landing-booking-steps.component.html'),
  controller: function () {
    'ngInject';
  }
};
